import React, {ReactElement} from 'react'
import EventEmitterExGuest from '../components/shared/pageBaseComponents/EventEmitterExGuest'
import NatCondominiumRepo from './components/condominium/repository/NatCondominiumRepo'
import NatCurrentDateTimeRepo from './components/currentDateTime/repository/NatCurrentDateTimeRepo'
import HolidaysRepository from '../components/HolidaysRepository'
import {NatOwnershipTransfersRepo} from './components/ownershipTransfers/repository/NatOwnershipTransfersRepo'
import NatOwnershipTransfersAgreementPage
    from './components/ownershipTransfers/guest/NatOwnershipTransfersAgreementPage'
import NatGuestIntermediaryConfirmPage from './components/ownershipTransfers/guest/NatGuestIntermediaryConfirmPage'
import NatGuestLoginRepo from './components/login/repository/NatGuestLoginRepo'
import NatGuestMyPage from './components/mypage/NatGuestMyPage'
import NatGuestIntermediaryInputPage from './components/ownershipTransfers/guest/NatGuestIntermediaryInputPage'
import NatOwnershipTransfersCompletePage from './components/ownershipTransfers/guest/NatOwnershipTransfersCompletePage';
import {AUTHENTICATION_CODE_TYPE, ROLE_FOR_GUEST} from '../CodeMaster';
import NatGuestContactusPage from './components/contactus/NatGuestContactusPage';
import NatGuestExternalTransmissionPage from './components/externalTransmission/NatGuestExternalTransmissionPage';
import NatGuestSystemErrorPage from './components/error/NatGuestSystemErrorPage'
import NatGuestOldMemberInputPage from './components/ownershipTransfers/guest/NatGuestOldMemberInputPage'
import NatGuestOldMemberConfirmPage from './components/ownershipTransfers/guest/NatGuestOldMemberConfirmPage'
import NatOwnershipTransfersNewMemberInputPage from './components/ownershipTransfers/guest/NatGuestNewMemberInputPage'
import NatOwnershipTransfersNewMemberInputOutlinePage
    from './components/ownershipTransfers/guest/NatGuestNewMemberInputOutlinePage'
import NatNewMemberPaymentChangeDateConfirmPage
    from './components/ownershipTransfers/guest/NatNewMemberPaymentChangeDateConfirmPage'
import NatOldMemberPaymentChangeDateConfirmPage
    from './components/ownershipTransfers/guest/NatOldMemberPaymentChangeDateConfirmPage'
import NatGuestNewMemberConfirmPage from './components/ownershipTransfers/guest/NatGuestNewMemberConfirmPage'
import NatOwnershipTransfersTerms from './components/ownershipTransfers/common/NatOwnershipTransfersTerms'
import NatSessionRepo from './components/session/repository/NatSessionRepo'
import {NatTwoFactorAuthRepo} from './components/twoFactorAuth/repository/NatTwoFactorAuthRepo'
import NatGuestTwoFactorAuthSendPage from './components/twoFactorAuth/NatGuestAuthCodeSendPage'
import NatGuestTwoFactorAuthInputPage from './components/twoFactorAuth/NatGuestAuthCodeInputPage'
import {Route} from 'react-router-dom'
import RouterPropsInjector from '../components/shared/RouterPropsInjector'

interface Props {
    eventEmitter: EventEmitterExGuest
    guestLoginRepo: NatGuestLoginRepo
    condominiumRepo: NatCondominiumRepo
    currentDateTimeRepo: NatCurrentDateTimeRepo
    ownershipTransfersRepo: NatOwnershipTransfersRepo
    holidaysRepo: HolidaysRepository
    sessionRepo: NatSessionRepo
    twoFactorAuthRepo: NatTwoFactorAuthRepo
}

export function SubRoutesGuest(routesProps: Props): ReactElement {
    const {
        eventEmitter,
        condominiumRepo,
        currentDateTimeRepo,
        ownershipTransfersRepo,
        holidaysRepo,
        guestLoginRepo,
        sessionRepo,
        twoFactorAuthRepo,
    }: Props = routesProps
    // 各申請の同意画面、入力画面、確認画面、完了画面、詳細画面を定義する
    return (<>
        <Route
            path="/guest/error"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestSystemErrorPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'システムエラー画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/contents/policy"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersTerms
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'利用規約 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/mypage"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestMyPage
                    navigate={props.navigate}
                    location={props.location}
                    guestLoginRepo={guestLoginRepo}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    sessionRepo={sessionRepo}
                    eventEmitter={eventEmitter}
                    pageTitle={'組変トップページ | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/input"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestIntermediaryInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />

        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/input/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestIntermediaryInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    applyId={props.params.applyId}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />

        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestIntermediaryConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />

        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/confirm/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestIntermediaryConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    applyId={props.params.applyId}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.INTERMEDIARY}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'手続き説明画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.OLD_MEMBER}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'手続き説明画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/agreement"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersAgreementPage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.NEW_MEMBER}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'手続き説明画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/intermediary/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersCompletePage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.INTERMEDIARY}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'提出完了画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersCompletePage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.OLD_MEMBER}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'提出完了画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/complete"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersCompletePage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    roleId={ROLE_FOR_GUEST.NEW_MEMBER}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'提出完了画面 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/contactus"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestContactusPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    pageTitle={'お問い合わせ | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/externalTransmission"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestExternalTransmissionPage
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'利用者情報の外部送信 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/paymentChangeDateConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatNewMemberPaymentChangeDateConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'支払変更期日の確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/paymentChangeDateConfirm"
            element={<RouterPropsInjector>{(props) =>
                <NatOldMemberPaymentChangeDateConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'支払変更期日の確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/input"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestOldMemberInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/input/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestOldMemberInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    applyId={props.params.applyId}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestOldMemberConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/old-member/confirm/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestOldMemberConfirmPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    applyId={props.params.applyId}
                    currentDateTimeRepo={currentDateTimeRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/outline"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersNewMemberInputOutlinePage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力（１/２） | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/detail"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersNewMemberInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力（２/２） | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/outline/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersNewMemberInputOutlinePage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力（１/２） | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/detail/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatOwnershipTransfersNewMemberInputPage
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    holidaysRepo={holidaysRepo}
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容入力（２/２） | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/confirm"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestNewMemberConfirmPage
                    condominiumCd={props.params.condominiumCd!}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/condominiums/:condominiumCd/applications/ownership-transfers/new-member/confirm/:applyId"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestNewMemberConfirmPage
                    condominiumCd={props.params.condominiumCd!}
                    applyId={props.params.applyId}
                    ownershipTransfersRepo={ownershipTransfersRepo}
                    condominiumRepo={condominiumRepo}
                    currentDateTimeRepo={currentDateTimeRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'組合員資格変更届_申請内容確認 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/two-factor-auth/1/send"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestTwoFactorAuthSendPage
                    twoFactorAuthRepo={twoFactorAuthRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'認証コード送信 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
        <Route
            path="/guest/two-factor-auth/1/input/:authType"
            element={<RouterPropsInjector>{(props) =>
                <NatGuestTwoFactorAuthInputPage
                    authType={AUTHENTICATION_CODE_TYPE
                        .codeToEnumConstants(props.params.authType!)}
                    twoFactorAuthRepo={twoFactorAuthRepo}
                    navigate={props.navigate}
                    location={props.location}
                    eventEmitter={eventEmitter}
                    pageTitle={'認証コード入力 | 素敵ネット'}
                />
            }</RouterPropsInjector>}
        />
    </>)
}
